var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYellowLove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twemoji:red-heart",
    clipPath: "url(#clip0_1500_1634)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M71.9336 46.9836C76.4752 39.1172 73.7801 29.0587 65.9151 24.5178C61.1404 21.7612 55.5664 21.6857 50.9013 23.7959C50.3962 18.7007 47.5438 13.9112 42.7706 11.1553C34.9042 6.61367 24.8465 9.3074 20.304 17.1752C19.6607 18.2895 19.1788 19.4508 18.8204 20.6315C13.7037 34.0606 19.8811 54.9111 27.618 64.1238C39.4634 66.2169 60.6105 61.1423 69.6784 49.9963C70.5246 49.0973 71.2894 48.0993 71.9336 46.9836Z",
    fill: "#F1CB3D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1500_1634"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(30) rotate(30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowLove);
export default __webpack_public_path__ + "static/media/yellowLove.a7bf6abf7ae95d180b0d5d5c6f848959.svg";
export { ForwardRef as ReactComponent };